<div
  data-wizard-target="revision-drop-choice-interaction"
  class="top-revision-keep flex-column gap-8 mat-elevation-z3"
>
  <span>Set as latest?</span>
  <div class="flex-row gap-16">
    <button
      data-cy="accept-revision"
      mat-icon-button
      color="light"
      class="radius-mid density-mid"
      (click)="handleRevision.emit(true)"
    >
      <generic-icon
        [iconConfiguration]="{
          renderEntity: 'check',
          renderType: 'symbol'
        }"
      />
    </button>
    <button
      data-cy="decline-revision"
      color="light"
      mat-icon-button
      class="radius-mid density-mid"
      (click)="handleRevision.emit(false)"
    >
      <generic-icon
        [iconConfiguration]="{
          renderEntity: 'close',
          renderType: 'symbol'
        }"
      />
    </button>
  </div>
</div>
